export default {
      id: "refresh-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.b0d228b5.svg#refresh",
      toString: function () {
        return this.url;
      }
    }